import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { useWishlist } from "@/context/WishlistContext";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import Reveal from "@/components/Reveal";

export default function Wishlist() {
  const { t } = useLanguage();
  const { slugs } = useWishlist();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    api.products().then((all) => setProducts(all.filter((p) => slugs.includes(p.slug)))).catch(() => {});
  }, [slugs]);

  return (
    <div data-testid="wishlist-page" className="bg-white">
      <section className="relative overflow-hidden border-b border-navy/10 bg-surface pb-16 pt-28">
        <span aria-hidden className="text-ghost pointer-events-none absolute -bottom-8 end-0 select-none font-display text-[14vw] italic leading-none">
          Wishlist
        </span>
        <div className="relative mx-auto max-w-7xl px-6">
          <Reveal><p className="label-luxe text-gold-dark">{t.wish.kicker}</p></Reveal>
          <Reveal delay={1}>
            <h1 className="mt-5 font-display text-5xl font-light tracking-tight text-navy sm:text-6xl">{t.wish.title}</h1>
          </Reveal>
          <Reveal delay={2}>
            <p className="mt-5 text-sm font-light text-navy/50">{t.wish.sub}</p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-6 py-20">
        {products.length === 0 ? (
          <div className="flex flex-col items-center gap-6 py-20">
            <Heart size={36} strokeWidth={1} className="text-navy/20" />
            <p data-testid="wishlist-empty" className="text-sm text-navy/50">{t.wish.empty}</p>
            <Link to="/shop" data-testid="wishlist-empty-cta" className="btn-outline-luxe">{t.wish.emptyCta}</Link>
          </div>
        ) : (
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {products.map((p, i) => (
              <ProductCard key={p.slug} product={p} index={i} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
